import { Component } from '@angular/core';
@Component({
  selector: 'app-required',
  template: `<span> *</span>`,
  styles: ['span { color: red; }']
})
export class RequiredMarkerComponent {
}
